import { Fragment } from 'react';
import { rage } from '~/rage';
import { ShopShadow } from '~/components/ui/ShopShadow';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.CharacterCreation} />
		)}
		<ShopShadow />
	</Fragment>
);
export { Background };
